// extracted by mini-css-extract-plugin
export default {"ebanner":"Fi-z"};